import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue';
import EditorArchive from './components/EditorArchive.vue';
import { defaultVideoArchive, deleteVideoArchive, getVideoArchives } from '@/api/videoArchive';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "tableKey", 0);
    _defineProperty(_this, "list", []);
    _defineProperty(_this, "total", 0);
    _defineProperty(_this, "listLoading", true);
    _defineProperty(_this, "listQuery", {
      page: 1,
      size: 20,
      category: undefined,
      title: ''
    });
    _defineProperty(_this, "archiveTypes", [{
      label: 'THERAPIST_LIVE',
      key: 'THERAPIST_LIVE'
    }, {
      label: 'HOME_TRAINING',
      key: 'HOME_TRAINING'
    }]);
    _defineProperty(_this, "edit", {
      showDialog: false,
      title: '',
      action: '',
      archive: JSON.parse(JSON.stringify(defaultVideoArchive))
    });
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "onShowDialogChange",
    value: function onShowDialogChange(showDialog, oldValue) {
      if (showDialog === false) {
        this.getList();
      }
    }
  }, {
    key: "onQueryTitleChange",
    value: function onQueryTitleChange(title, oldValue) {
      var newTitle = title.replace(/[^a-z A-Z0-9ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '');
      if (newTitle === title) {
        return;
      }
      this.listQuery.title = newTitle;
    }
  }, {
    key: "created",
    value: function created() {
      this.getList();
    }
  }, {
    key: "getList",
    value: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var listQuery, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              listQuery = Object.assign({}, this.listQuery);
              listQuery.page = listQuery.page - 1;
              _context.n = 1;
              return getVideoArchives(listQuery);
            case 1:
              res = _context.v;
              this.list = res.data;
              this.total = res.total;
              this.listLoading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }()
  }, {
    key: "handleFilter",
    value: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    }
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return deleteVideoArchive(row.id);
            case 1:
              this.$message({
                message: 'Deleted Successfully',
                type: 'success'
              });
              this.getList();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleDelete(_x) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.edit = {
        showDialog: true,
        title: 'Create Archive',
        action: 'create',
        archive: JSON.parse(JSON.stringify(defaultVideoArchive))
      };
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(archive) {
      this.edit = {
        showDialog: true,
        title: 'Edit',
        action: 'edit',
        archive: JSON.parse(JSON.stringify(archive))
      };
    }
  }]);
}(Vue);
__decorate([Watch('edit.showDialog', {
  deep: true
})], default_1.prototype, "onShowDialogChange", null);
__decorate([Watch('listQuery.title', {
  deep: true
})], default_1.prototype, "onQueryTitleChange", null);
default_1 = __decorate([Component({
  name: 'VideoArchive',
  components: {
    Pagination: Pagination,
    EditorArchive: EditorArchive
  }
})], default_1);
export default default_1;